import axios from 'axios';
import { html, customElement } from '@adobe/edex/ui/edex-lit';
import * as resourceAPI from '@adobe/edex/ui/api/resource';
import { EdexDomID, EdexTagName, AdobeAnalyticsEvent } from '@adobe/edex/ui/shared/constants';
import styles from '@adobe/edex/ui/components/resource/save-to-od/save-to-od.lit.scss';
import { Onedrive } from '@adobe/edex/ui/config/onedrive';
import { BaseAuthElement } from '@adobe/edex/ui/components/base.element';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { openDialog } from '@adobe/edex/ui/store/routines';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { AnalyticsEvent } from '@adobe/edex/ui/constants';
import { SendToDriveDialogPayload } from '@adobe/edex/ui/types';
import { Analytics } from '@adobe/edex/ui/shared/config/analytics';
import { DownloadPayLoad } from '@adobe/edex/ui/types/payload';
import { trackTargetEvent } from '@adobe/edex/ui/shared/utils';

@customElement(EdexTagName.saveToOD)
export class SaveToOD extends BaseAuthElement {
  get useLightDom() {
    return true;
  }
  static styles = styles;
  static get properties() {
    return {
      ...super.properties,
      resourceID: { type: String },
      fileID: { type: String },
    };
  }
  resourceID: string;
  fileID: string;

  actions = {
    openDialog: openDialog.trigger,
  };

  handleClick = async () => {
    this.authGuard();

    this.track({
      event: AnalyticsEvent.resourceClickSendToOD,
      payload: { id: this.resourceID },
    });

    const accessToken = await Onedrive.getInstance().getAccessToken();
    if (!accessToken) {
      return;
    }

    const source = axios.CancelToken.source();
    this.actions.openDialog({
      id: EdexDomID.resourceSendToDriveProgressDialog,
      payload: {
        source,
      } as SendToDriveDialogPayload,
    });
    const {
      data: { link, folderName },
    } = await resourceAPI.exportToOD(this.resourceID, accessToken, this.fileID, {
      cancelToken: source.token,
    });

    Analytics.getInstance().emitEvent(AdobeAnalyticsEvent.resourceDownloadOneDrive, 'Resource download to OneDrive');
    trackTargetEvent('edex-resource-save-to-od-click');
    this.emitEvent<DownloadPayLoad>('success', { link, folderName });
  };

  render() {
    const src = '/ui/assets/onedrive-icon.png';
    return html`
      <sp-button variant="primary" @click="${this.handleClick}">
        <sp-icon slot="icon" size="s" src="${src}"></sp-icon>
        ${$t(I18nKey.sendToOneDrive)}
      </sp-button>
    `;
  }
}
